module.exports = __webpack_public_path__ + "img/Pinjam Yuk.fe7ab321.png";